<template>
  <div style="margin-top: 60px">
    <div class="filmbanner">
      <div class="filmbannerp1"><span>影视作品</span></div>
      <div class="filmbannerp2"><span>FILMGRAPHY</span></div>
    </div>
    <div class="content">
      <div class="showMvinfo">
        <div class="showMvinfo1" v-for="item in firstPage">
          <img class="showMvinfoPic1" :src="item.filemImg" alt="" onerror="src='../static/resource/errorpic.png'"/>
          <p class="showMvinfoPicdiscrib1">{{item.name}}</p>
        </div>
      </div>
      <div class="newsPagunationBox">
        <div class="newsPagunation">
          <img :src="moveLeftarrowpic" alt="" class="arrowL" @click="moveRight"/>
          <div class="numBox">
            <ul class="numBoxul" :class="{'positonActive':thepositionnum==0}" :style="tStyle">
              <li class='numBoxulli'
                  v-for="(item, index) in thePageNum"
                  @click="turntopage"
                  :data-id="index"
                  :class="{'active': hoverId == index}"
              >{{(item+1)}}
              </li>
            </ul>
          </div>
          <img :src="moveRightarrowpic" alt="" class="arrowR" @click="moveLeft"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Request from '../common/request.js';

  var request = new Request();
  var _this;
  var arr = [];
  var num;
  var pagenum;//分了多少页
  var pN = []
  var theSelectedPage = 0;
  var movenum = 0;
  var pagenums;
  export default {
    name: 'FilmgraphyPage',
    data: function () {
      return {
        firstPage: arr,
        thePageNum: [],
        hoverId: 0,
        tStyle: "left: -" + 450 * movenum + "px",
        moveLeftarrowpic: '../static/resource/arrowL.png',
        moveRightarrowpic: '../static/resource/arrowR.png',
        thepositionnum: 1
      }
    },
    methods: {
      turntopage: function (ev) {
        $('html, body').animate({scrollTop: 0}, 0);
        this.hoverId = ev.target.innerHTML - 1;
        theSelectedPage = ev.target.innerHTML - 1;
        this.getthefilm(ev.target.innerHTML);
      },
      moveLeft: function () {
        if (movenum < pagenums - 1) {
          movenum++;
        }
        if (pagenum > 9) {
          var ulwidth = (46 + 4) * pagenum
          $('.numBoxul').width(ulwidth);
        }
        if (pagenum > 9) {
          _this.thepositionnum = 0
        }
        _this.tStyle = "left: -" + (450 * movenum) + "px";
      },
      moveRight: function () {
        if (movenum > 0) {
          movenum--;
        }
        if (pagenum > 9) {
          var ulwidth = (46 + 4) * pagenum
          $('.numBoxul').width(ulwidth);
        }
        if (pagenum > 9) {
          _this.thepositionnum = 0
        }
        this.tStyle = "left: -" + (450 * movenum) + "px";
      },
      getthefilm: function (num) {
        //影视页面作品接口
        request.get({
          url: '/mengyang/film/getPortalFilmsList',
          params: {
            page: num,
            number: 8
          },
          callback(data) {
            arr = [];
            for (let i = 0; i < data.data.length; i++) {
              if (undefined == data.data[i].filemImg) {
                data.data[i].filemImg = '';
              }
            }
            data.data.forEach(function (ele) {
              if (ele.name.length > 20) {
                ele.name = ele.name.substring(0, 20) + '...'
              }
              arr.push(ele)
            })
            _this.firstPage = arr;
            pagenum = Math.ceil(data.totalNumber / 8);
            pN = []
            for (var b = 0; b < pagenum; b++) {
              pN[b] = b;
            }
            _this.thePageNum = pN;
            theSelectedPage = 0;
            movenum = 0;
            pagenums = Math.ceil(pagenum / 9);
          }
        })
      }
    },
    mounted: function () {
      _this = this;
      this.getthefilm(1);
      this.hoverId = theSelectedPage;
    }
  }
</script>

<style>
  .theBottom {
    position: fixed;
    bottom: 0;
    height: 40px;
    width: 100%;
    background: #282828;
    z-index: 10000;
  }

  .theBottom img {
    height: 40px;
  }

  .filmbanner {
    height: 224px;
    width: 100%;
    background: #74e5fe;
    text-align: center;
  }

  .filmbannerp1 {
    color: #666666;
    font-size: 48px;
    font-family: myFont;
    height: 60px;
    width: 100%;
    padding-top: 60px;
  }

  .filmbannerp2 {
    color: #666666;
    font-size: 24px;
    font-family: myFont;
    height: 50px;
    width: 100%;
  }

  .content {
    width: 1204px;
    height: auto;
    margin: 0 auto;
  }

  .showMvinfo {
    width: 1204px;
    height: 884px;
    margin-top: 40px;
  }

  .showMvinfo1 {
    float: left;
    width: 282px;
    height: 424px;
  }

  .showMvinfo1:nth-child(2) {
    margin-left: 25px;
  }

  .showMvinfo1:nth-child(3) {
    margin-left: 25px;
  }

  .showMvinfo1:nth-child(4) {
    margin-left: 25px;
  }

  .showMvinfo1:nth-child(5) {
    margin-top: 32px
  }

  .showMvinfo1:nth-child(6) {
    margin-left: 25px;
    margin-top: 32px
  }

  .showMvinfo1:nth-child(7) {
    margin-left: 25px;
    margin-top: 32px
  }

  .showMvinfo1:nth-child(8) {
    margin-left: 25px;
    margin-top: 32px
  }

  .showMvinfo1 > img {
    width: 282px;
    height: 394px;
  }

  .showMvinfo1 > p {
    cursor: pointer;
    display: inline-block;
    width: 282px;
    text-align: center;
    font-size: 22px;
    color: #000000;
    font-family: myFont;
    height: 56px;
    overflow: hidden;
  }

  .showMvinfo1 > span:hover {
    color: red;
  }

  .showMvinfo1:hover > img {
    color: red;
    cursor: pointer;
    box-shadow: 0px 0px 14px #e2e2e2;
  }

  .newsPagunationBox {
    box-sizing: border-box;
    padding-top: 40px;
    height: 172px;
  }

  .newsPagunation {
    height: 40px;
    width: 566px;
    margin: auto;
  }

  .newListL {
    width: 988px;
    height: 208px;
    float: left;
  }

  .newListR {
    width: 208px;
    height: 208px;
    float: left;
    box-sizing: border-box;
    padding: 6px;
  }

  .newListR > img {
    width: 196px;
    height: 196px;
  }

  .newListL1 {
    color: #000000;
    font-size: 28px;
    font-family: myFont;
    margin-left: 40px;
    margin-top: 34px;
    cursor: pointer;
  }

  .newListL2 {
    color: #969696;
    font-size: 22px;
    font-family: myFont;
    margin-left: 40px;
    margin-top: 14px;
  }

  .newListL3 {
    color: #969696;
    font-size: 22px;
    font-family: myFont;
    margin-left: 40px;
    margin-top: 20px;
    width: 880px;
  }

  .arrowL {
    cursor: pointer;
    float: left;
  }

  .arrowR {
    cursor: pointer;
    float: left;
    margin-left: 8px;
  }

  .numBox {
    position: relative;
    float: left;
    width: 454px;
    height: 40px;
    margin-left: 12px;
    text-align: center;
    overflow: hidden;
  }

  .numBoxul {
    display: inline-block;
    height: 40px;
    text-align: center;
    transition: .5s;
  }

  .numBox li {
    float: left;
    width: 46px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ecf1f0;
    margin-left: 4px;
  }

  .numBox li:hover {
    color: white;
    background: #74e5fe;
  }

  .numBoxulli:hover, .numBox
  .active {
    cursor: pointer;
    background-color: #74e5fe;
  }

  .positonActive {
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/filmgraphyPage.vue